exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-menu-panel .mat-menu-content {\n  width: 350px !important; }\n\n.mat-menu-item {\n  color: #17485D;\n  line-height: 16px;\n  height: 45px;\n  width: 350px;\n  padding-top: 5px;\n  border-bottom: 2px solid #F5F5F5; }\n  .mat-menu-item div {\n    padding-left: 5px; }\n  .mat-menu-item:first-child {\n    padding-top: 5px; }\n  .mat-menu-item:last-child {\n    border-bottom: none; }\n  .mat-menu-item:hover {\n    background: #fff; }\n\n.mat-menu-content {\n  padding-bottom: 0; }\n\n.menu-trigger {\n  margin-left: 0.5rem; }\n  .menu-trigger:hover {\n    cursor: pointer; }\n  .menu-trigger .circle {\n    position: absolute;\n    top: -2px;\n    right: -8px;\n    color: #fff;\n    background: #FF9633;\n    font-size: 11px;\n    line-height: 11px;\n    padding: 3px 6px 3px 6px;\n    height: 20px;\n    border-radius: 50%;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/notifications/notifications.component.scss
// module id = ../../../../../src/app/core/template/notifications/notifications.component.scss
// module chunks = 10